import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-import',
  templateUrl: './blog-import.component.html',
  styleUrls: ['./blog-import.component.scss']
})
export class BlogImportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
